import React from 'react';
import styled from '@emotion/styled';
import { backgroundColor as systemBackgroundColor } from 'styled-system';

import type { BackgroundColorProps } from '../../theme/system-types';
import type { ResponsiveImageBreakpointWidths } from '../../types/Image';
import ResponsiveImage from '../ResponsiveImage';

export interface CardImageProps {
  src: string;
  alt: string;
  tabIndex?: number;
}

const IMG_SIZES: ResponsiveImageBreakpointWidths = [56, 72, 96];

const StyledResponsiveImage = styled(ResponsiveImage)<BackgroundColorProps>`
  ${systemBackgroundColor};
`;

const CardImage = (props: CardImageProps) => (
  <StyledResponsiveImage {...props} widths={IMG_SIZES} />
);

export default CardImage;
